module.exports = __webpack_public_path__ + "assets/img/modal-avatar-a22f6c04.png";